import React, { useCallback, useMemo, useState } from "react";
import { Icon } from "@iconify/react";
import MasterLayout from "../masterLayout/MasterLayout";
import PerformanceDashboardLayer from "../components/dashboards/PerformanceDashboardLayer";

const PerformanceDashboardPage = () => {
  const [pageTitle, setPageTitle] = useState("Performance Dashboard");
  const [isPaused, setIsPaused] = useState(false);

  const handleTogglePause = useCallback(() => {
    setIsPaused((prev) => !prev);
  }, []);

  const headerRightActions = useMemo(() => (
    <button
      type="button"
      className="btn btn-link p-0 text-decoration-none"
      onClick={handleTogglePause}
      aria-label={isPaused ? "Resume dashboard cycling" : "Pause dashboard cycling"}
    >
      <Icon
        icon={isPaused ? "mdi:play" : "mdi:pause"}
        className="icon text-muted"
        style={{fontSize: "48px"}}
      />
    </button>
  ), [handleTogglePause, isPaused]);

  return (
    <>
      <MasterLayout pageTitle={pageTitle} headerRightActions={headerRightActions}>
        <PerformanceDashboardLayer onTitleChange={setPageTitle} isPaused={isPaused} />
      </MasterLayout>
    </>
  );
};

export default PerformanceDashboardPage;
